import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { apiCaller } from "@utils";
import { toast } from 'react-toastify';
import FormFreeText from './ComponentFreeText/FormFreeText';
import styled from 'styled-components';
import Success from '@images/login/success.svg'
import { Icon } from '@components/common'
import { ButtonComponent } from "@components/patterns/elements/Button";
import { useHistory } from 'react-router-dom';

const WrapSuccessGenerate = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 150px;
  gap: 32px;
  .title-note {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 18px;
    h1 {
      color: #121926;
      text-align: center;
      font-size: 24px;
      font-weight: 600;
    }
    p {
      color: #697586;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px; /* 150% */
      text-align: center;
    }
  }
  .action-success {
    display: flex;
    align-items: center;
    gap: 12px;
    button {
      width: 265px;
      font-size: 18px;
      line-height: 28px;
    }
  }
`

export default function GenerateFreeText() {
  const history = useHistory()
  const [loadingResult, setLoadingResult] = useState(false)
  const [dataAnalyze, setDataAnalyze] = useState()

  const {
    register,
    handleSubmit,
    setValue,
    control,
    watch
  } = useForm()

  const handleUpload = (data) => {
    const params = {
      Action: "Create",
      Type: "free_text",
      QuestionText: data?.question,
      Rubric: {
        instruction_text: data?.rubrics,
      },
      ModelAnswer: data?.answer
    }
    setLoadingResult(true)
    apiCaller(`/api/feedback/question/items/`, 'POST', params).then(res => {
      // const data = res && res.data;
      if (res.status === 200) {
        setDataAnalyze(res.data)
        setLoadingResult(false)
      } else {
        toast.error("Create new free-text question failed!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setLoadingResult(false)
      }
    });
  };

  const onSubmit = (data) => {
    handleUpload(data);
  }

  const handleCreateAnother = () => {
    setDataAnalyze()
    setValue('question', '')
    setValue('answer', '')
    setValue('rubrics', '')
  }

  return (
    <div className="wrapper -freeTextPage">
      <form className="form-platform" onSubmit={handleSubmit(onSubmit)}>
        {!dataAnalyze ? (
          <FormFreeText 
            register={register}
            setValue={setValue}
            handleSubmit={handleSubmit}
            control={control}
            watch={watch}
            loadingResult={loadingResult}
            setLoadingResult={setLoadingResult}
          />
        ) : (
          <WrapSuccessGenerate>
            <Icon src={Success}/>
            <div className="title-note">
              <h1>Free-text Question Created Successfully!</h1>
              <p>Your question has been saved to the Question Bank. <br />What would you like to do next?</p>
            </div>
            <div className='action-success'>
              <ButtonComponent size="large" color="outline" onClick={handleCreateAnother}>
                Create Another
              </ButtonComponent>
              <ButtonComponent size="large" onClick={() => history.push("/teach/inventory")}>
                Visit the Question Bank
              </ButtonComponent>
            </div>
          </WrapSuccessGenerate>
        )}
      </form>
    </div>
  )
}
